import { mapActions, mapState } from 'vuex';
import router from '@/router';

export default {
  created() {
    if (localStorage.lastKycPage) {
      const route = { name: localStorage.lastKycPage };
      if (localStorage.lastKycPageIdParam) {
        route.params = { id: localStorage.lastKycPageIdParam };
      }
      router.replace(route);
      localStorage.removeItem('lastKycPage');
      localStorage.removeItem('lastKycPageIdParam');
    }
    this.fetch().then(() => {
      if (router.currentRoute.name === 'KycIntroduction' &&
          this.form && this.form.attributes.introductionValidatedAt) {
        router.replace('/kyc');
      }
    });
    this.resetBanner();
  },

  computed: {
    ...mapState('kyc', ['form']),
    needSpouseFinancial() {
      return (
        (this.form.attributes.maritalStatus === 'Marié(e)' &&
        this.form.attributes.marriageType !== 'Communauté universelle') ||
        this.form.attributes.maritalStatus === 'Pacsé(e)');
    },
  },

  methods: {
    ...mapActions(['resetBanner']),
    ...mapActions('kyc', ['update', 'fetch']),
    close() {
      localStorage.kycLastPage = router.currentRoute.name;
      router.push('/opportunities');
    },
  },
};
